import React from 'react';

// Quiet chip on a trade order line showing what happened to that line when the
// invoice was generated: deducted from Square, bypassed (made-to-order), pushed
// below zero, or failed. Renders nothing before invoicing.
export default function SquareSyncTag({ result }) {
  if (!result) return null;

  if (result.status === 'skipped') {
    return (
      <span
        title={result.reason}
        className="text-[9px] font-bold tracking-widest text-white/30 border border-white/15 px-1.5 py-0.5"
      >
        SQUARE SYNC BYPASSED
      </span>
    );
  }

  if (result.status === 'failed') {
    return (
      <span
        title={result.reason}
        className="text-[9px] font-bold tracking-widest text-red-400 border border-red-400/30 px-1.5 py-0.5"
      >
        SQUARE FAILED
      </span>
    );
  }

  if (result.below_zero) {
    return (
      <span
        title={`Square level now ${result.square_level_after}`}
        className="text-[9px] font-bold tracking-widest text-red-400 border border-red-400/30 px-1.5 py-0.5"
      >
        BELOW ZERO
      </span>
    );
  }

  if (result.status === 'restocked') {
    return (
      <span className="text-[9px] font-bold tracking-widest text-green-400 border border-green-400/30 px-1.5 py-0.5">
        SQUARE +{result.qty}
      </span>
    );
  }

  return (
    <span
      title={result.square_level_after != null ? `Square level now ${result.square_level_after}` : undefined}
      className="text-[9px] font-bold tracking-widest text-cyan-400 border border-cyan-400/30 px-1.5 py-0.5"
    >
      SQUARE −{result.qty}
    </span>
  );
}